var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound11BSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 30,
  r: 9,
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  transform: "rotate(-180 39 30)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M15 35V25l8.274-.752A2.5 2.5 0 0 1 26 26.738v6.524a2.5 2.5 0 0 1-2.726 2.49L15 35Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m17 36-.445-.223A2.813 2.813 0 0 1 15 33.262v-6.524c0-1.065.602-2.039 1.555-2.515L17 24"
})));
SvgRound11BSelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound11BSelected);
export default ForwardRef;